// extracted by mini-css-extract-plugin
export default {"dashboardImageContainer":"Banner_dashboardImageContainer__gWEXI","links":"Banner_links__jvLIC"};